import ROUTES from '@src/constants/route';

export const sideBarListOptions = [
  {
    id: 1,
    label: 'Thông tin ứng dụng',
    path: ROUTES.APP_DETAIL_INFO,
  },
  {
    id: 3,
    label: 'Lịch sử phát hành',
  },
  {
    id: 4,
    label: 'Quản lý gói cước',
    path: ROUTES.APP_PACKAGES_MANAGEMENT,
  },
];

export const sideBarListOptionsGenAI = [
  {
    id: 5,
    label: 'Quản lý công cụ',
    path: ROUTES.APP_TOOL_MANAGEMENT,
  },
  {
    id: 6,
    label: 'Quản lý danh mục',
    path: ROUTES.APP_CATEGORY_MANAGEMENT,
  },
  {
    id: 7,
    label: 'Quản lý credit',
    path: ROUTES.APP_CREDIT_MANAGEMENT,
  },
  {
    id: 8,
    label: 'Quản lý gói người dùng',
    path: ROUTES.APP_USER_PACKAGES_MANAGEMENT,
  },
];
